import { PayloadAction } from '@reduxjs/toolkit';
import { useEffect } from 'react';
import { deviceSlice } from '../../common/store/deviceSlice';
import { appStore } from '../../common/store/store';
import { apiJson } from '../api';

export const usePageVisibility = () => {
  useEffect(() => {
    let lastVisibilityChange = Date.now();

    const handleVisibilityChange = async () => {
      if (!document.hidden) {
        const timeSinceHidden = Date.now() - lastVisibilityChange;
        // Recharger si inactif plus de 5 minutes (300000ms)
        if (timeSinceHidden > 300000) {
          const loadedRoutes = appStore.getState().device.loadedRoutes;

          // Vider les routes chargées pour forcer le rechargement
          appStore.dispatch(deviceSlice.actions.clearLoadedRoutes());

          // Recharger la route actuelle
          const currentPath = window.location.pathname;
          if (loadedRoutes.includes(currentPath)) {
            appStore.dispatch(deviceSlice.actions.setLoading(true));
            const result: PayloadAction | PayloadAction[] = await apiJson(currentPath, 'get', null, { headers: { 'Accept': 'application/json' } });
            appStore.dispatch(deviceSlice.actions.setLoading(false));

            if (Array.isArray(result)) {
              result.map(appStore.dispatch);
            } else {
              appStore.dispatch(result);
            }
            appStore.dispatch(deviceSlice.actions.onRoute(currentPath));
          }
        }
      } else {
        lastVisibilityChange = Date.now();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);
};
